import { render, staticRenderFns } from "./Msn.vue?vue&type=template&id=f6b429c2&"
import script from "./Msn.vue?vue&type=script&lang=js&"
export * from "./Msn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports